<template>
    <v-card class="elevation-12">
        <v-toolbar dark color="primary">
            <v-toolbar-title>Login Form</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-6">
            <v-form ref="form" v-model="valid" lazy-validation>
                <v-text-field prepend-icon="person" name="email" label="Email" type="email"
                              v-model="email" :rules="emailRules" required>
                </v-text-field>
                <v-text-field prepend-icon="lock" name="password" label="Password" id="password"
                              type="password" required v-model="password" :rules="passwordRules">
                </v-text-field>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <p id="result-message" class="ml-3" width="140px">
                {{resultMessage}}
            </p>
            <v-spacer></v-spacer>
            <v-btn color="primary" :disabled="!valid" @click="submitLoginCredentials">Login</v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
export default {
    name: 'LoginModal',
    data() {
        return {
            valid: false,
            email: '',
            password: '',
            emailRules: [
                v => !!v || 'E-mail is required',
                v => /.+@.+/.test(v) || 'E-mail must be valid'
            ],
            passwordRules: [
                v => !!v || 'Password is required',
                v =>
                    v.length >= 6 ||
                    'Password must be greater than 6 characters'
            ],
            resultMessage: ''
        };
    },
    methods: {
        submitLoginCredentials() {
            if (this.$refs.form.validate()) {
                this.$store.dispatch('userLogin', {
                    email: this.email,
                    password: this.password
                }).then(successfulLogin => {
                    let that = this;
                    if (successfulLogin) {
                        this.resultMessage = 'You have successfully logged in!'
                        document.getElementById("result-message").classList.remove('red--text');
                        document.getElementById("result-message").classList.add('green--text');

                        setTimeout(function(){
                            that.$emit('loggedIn')
                        }, 2000);
                    } else {
                        this.resultMessage = 'Your e-mail/password is wrong'
                        document.getElementById("result-message").classList.remove('green--text');
                        document.getElementById("result-message").classList.add('red--text');
                    }
                }, (error) => {
                    this.resultMessage = 'Something went wrong. Please try again later'
                    document.getElementById("result-message").classList.remove('green--text');
                    document.getElementById("result-message").classList.add('red--text');
                })
            }
        }

    }
};
</script>

<style scoped>
#result-message {
    width: 200px
}
</style>
